import { render, staticRenderFns } from "./ChapterDialog.vue?vue&type=template&id=6ad477a6&"
import script from "./ChapterDialog.vue?vue&type=script&lang=ts&"
export * from "./ChapterDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports